import '@/css/app.css'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

import 'simple-lightbox/dist/simpleLightbox.min.css'

//import { simpleLightbox } from './components/defaults'

import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
Alpine.plugin([focus, collapse])

interface BlockInit {
    init: (element: Element) => Promise<void>
}

interface ComponentInit {
    init: (element: Element) => Promise<void>
}

type DynamicComponent = {
    selector: string
    method: string
};

const main = async () => {
    // simpleLightbox()
    // linksNewWindow()
    // newsletter()

    const dynamicComponents: DynamicComponent[] = [
        //{ selector: '.gsapBatchUpBase', method: 'gsapBatchUpBase' },
        //{ selector: '.swiperDefault', method: 'swiperDefault' },
    ]
    dynamicComponents.forEach(({ selector, method }) => {
        if (document.querySelector(selector)) {
            import('./components/defaults').then(module => {
                if (method in module) {
                    (module as any)[method]()
                }
            }).catch(error => console.error(`Error loading ${method}:`, error))
        }
    })

    // Type your arrays more strictly
    const blocks: readonly string[] = []
    const components: readonly string[] = ['navMobile']

    const promises: Promise<void>[] = []

    for (const block of blocks) {
        const blockElements = document.querySelectorAll(`[data-type="${block}"]`)

        const { init } = await import(`./blocks/${block}.ts`)

        blockElements.forEach((block) => {
            promises.push(init(block))
        });
    }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)

        const { init } = await import(`./components/${comp}.ts`)

        compElements.forEach((comp) => {
            promises.push(init(comp))
        })
    }

    await Promise.all(promises).catch((e: Error) => {
        console.error(e.message, e)
    })
}
/*
const newsletter = (): void => {
    const newsletterButton = document.querySelector('a[href="#newsletter"]')     // Listener
    const newsletterTrigger = document.getElementById('newsletter-button')  // Trigger

    if (newsletterButton) {
        newsletterButton.addEventListener('click', triggerNewsletterOpen)
    }

    function triggerNewsletterOpen() {
        if (newsletterTrigger) {
            newsletterTrigger.click()
        }
    }
}

const linksNewWindow = (): void => {
    const links = document.querySelectorAll<HTMLAnchorElement>('main a')

    links.forEach(link => {
        if (link.hostname !== window.location.hostname || link.href.includes('uploads/files')) {
            link.rel = 'noopener noreferrer'
            link.target = '_blank'
        }
    });
}
*/
main().then(() => {
    console.info('Vite <3')
    Alpine.start()
})